import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import AlmigDropdown, { genAlmigDropdownItems, genAlmigDropdownTitle } from "../grundelemente/AlmigDropDown";
import AlmigSlider from "../grundelemente/AlmigSlider";
import UnitValue from "../einheiten/UnitValue";
import UnitText from "../einheiten/UnitText";

import "./WaermerueckgewinnungParameter.css";

const rueckfuehrungsIndex = [
	{ i18n_key: "Oil circulation", value: 0 },
	{ i18n_key: "Air pipes", value: 1 }
];

const heizmaterialIndex = [
	{ i18n_key: "Heating oil", value: 0 },
	{ i18n_key: "City gas", value: 1 }
];

const WRGSlider = props => (
	<div className="wrg-slider">
		<AlmigSlider value={props.value} setValue={props.setValue}
			min={props.min} max={props.max} step={props.step} />
		<UnitValue value={props.value} unit={props.unit} units={props.units} />
		<UnitText unit={props.unit} units={props.units} />
	</div>
);

WRGSlider.propTypes = {
	value: PropTypes.number.isRequired,
	setValue: PropTypes.func.isRequired,
	min: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	step: PropTypes.number.isRequired,
	unit: PropTypes.string.isRequired,
	units: PropTypes.object.isRequired
};

WRGSlider.defaultProps = {
	step: 1
};

const WaermerueckgewinnungParameter = props => (
	<div className="waermerueckgewinnungparameter">
		<FormattedMessage id="Heat reclaiming through" /><br />
		<AlmigDropdown id="rückführungsindex"
			title={genAlmigDropdownTitle(rueckfuehrungsIndex, props.parameter.rueckfuehrungsIndex)}>
			{ genAlmigDropdownItems(rueckfuehrungsIndex, props.setRueckfuehrungsIndex)}
		</AlmigDropdown><br />
		<FormattedMessage id="Replaced heating material" /><br />
		<AlmigDropdown id="heizmaterialindex"
			title={genAlmigDropdownTitle(heizmaterialIndex, props.parameter.heizmaterialIndex)}>
			{ genAlmigDropdownItems(heizmaterialIndex, props.setHeizmaterialIndex)}
		</AlmigDropdown><br />
		<FormattedMessage id="Use of heat reclaiming" /><br />
		<WRGSlider value={props.parameter.nutzungszeitraumWRG_percent}
			setValue={props.setNutzungszeitraumWRG}
			min={0} max={1} step={0.01}
			unit="percent" units={props.units} /><br />
		<FormattedMessage id="Heating efficiency" /><br />
		<WRGSlider value={props.parameter.heizungWirkungsgrad_percent}
			setValue={props.setHeizungWirkungsgrad}
			min={0} max={1} step={0.01}
			unit="percent" units={props.units} /><br />
		<FormattedMessage id="Cold water in" /><br />
		<WRGSlider value={props.parameter.kaltesWasserEin_degC}
			setValue={props.setKaltesWasserEin}
			min={10} max={39}
			unit="temperature" units={props.units} /><br />
		<FormattedMessage id="Warm water out" /><br />
		<WRGSlider value={props.parameter.warmesWasserAus_degC}
			setValue={props.setWarmesWasserAus}
			min={40} max={70}
			unit="temperature" units={props.units} /><br />
	</div>
);

WaermerueckgewinnungParameter.propTypes = {
	parameter: PropTypes.object.isRequired,
	units: PropTypes.object.isRequired,
	setRueckfuehrungsIndex: PropTypes.func.isRequired,
	setHeizmaterialIndex: PropTypes.func.isRequired,
	setNutzungszeitraumWRG: PropTypes.func.isRequired,
	setHeizungWirkungsgrad: PropTypes.func.isRequired,
	setKaltesWasserEin: PropTypes.func.isRequired,
	setWarmesWasserAus: PropTypes.func.isRequired
};

export default WaermerueckgewinnungParameter;
